/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}[_nghost-%COMP%]   .email-input[_ngcontent-%COMP%]{background:0 0;border:none}[_nghost-%COMP%]   .email-input[_ngcontent-%COMP%]:focus{outline:0;box-shadow:none}"];
export { styles as styles };
